import type { PropsWithChildren } from "react";
import { FontPreloads } from "@/features/site-shell/media";

export default function SugarscapeSurface({
  children,
}: Readonly<PropsWithChildren>) {
  return (
    <div className="sugarscape-fonts" style={{ background: "#14100a" }}>
      <FontPreloads group="sugarscape" />
      {children}
    </div>
  );
}
